module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main main--services services"
  }, [_c('div', [_c('div', {
    ref: "main",
    staticClass: "group group--last"
  }, [_c('div', {
    staticClass: "services__grid"
  }, [_c('div', {
    staticClass: "services__heading"
  }, [_c('h1', {
    staticClass: "h1",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v(_vm._s(_vm.service.intro.heading))]), _vm._v(" "), _vm._l((_vm.service.intro.copy), function(p, index) {
    return _c('p', {
      key: ("introCopy" + index),
      staticClass: "small",
      domProps: {
        "innerHTML": _vm._s(p)
      }
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "services__cta"
  }, [(_vm.service.cta.number) ? _c('h2', {
    staticClass: "h2 mb0",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("Call "), _c('a', {
    staticClass: "tdn",
    attrs: {
      "href": ("tel:" + (_vm.service.cta.number))
    }
  }, [_vm._v(_vm._s(_vm._f("phone")(_vm.service.cta.number)))])]) : _vm._e(), _vm._v(" "), (_vm.service.cta.number) ? _c('p', {
    staticClass: "p mt0 small",
    domProps: {
      "innerHTML": _vm._s(_vm.service.cta.copy)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.service.cta.buttons) ? _c('div', _vm._l((_vm.service.cta.buttons), function(button, index) {
    return _c('module-button', _vm._b({
      key: ("extraInfoButton" + index),
      nativeOn: {
        "click": function($event) {
          return _vm.getServiceProviders(button.action)
        }
      }
    }, 'module-button', button, false))
  }), 1) : _vm._e(), _vm._v(" "), _c('hr')]), _vm._v(" "), (_vm.service.extraInfo) ? _c('div', {
    staticClass: "services__extra"
  }, [_vm._l((_vm.service.extraInfo), function(section, index) {
    return _c('div', {
      key: ("extraInfo" + index)
    }, [_c('h2', {
      staticClass: "h2 mt0",
      style: ({
        'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
      })
    }, [_vm._v(_vm._s(section.heading))]), _vm._v(" "), _vm._l((section.copy), function(p, index) {
      return _c('p', {
        key: ("extraInfoCopy" + index),
        staticClass: "small",
        domProps: {
          "innerHTML": _vm._s(p)
        }
      })
    }), _vm._v(" "), (section.buttons) ? _c('div', _vm._l((section.buttons), function(button, index) {
      return _c('module-button', _vm._b({
        key: ("extraInfoButton" + index)
      }, 'module-button', button, false))
    }), 1) : _vm._e()], 2)
  }), _vm._v(" "), _c('hr')], 2) : _vm._e(), _vm._v(" "), _c('div', {
    class: [
      "services__icon-list",
      {
        'services__icon-list--legal': _vm.isLegal
      }
    ]
  }, [_c('module-info-list', {
    attrs: {
      "sections": _vm.service.iconList
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "services__help-list"
  }, [_c('hr'), _vm._v(" "), _c('h2', {
    staticClass: "h2 mt0",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("We can help you with")]), _vm._v(" "), _c('module-help-list', {
    attrs: {
      "items": _vm.service.helpList
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "services__image"
  }, [_c('img', {
    class: [
      'services__img',
      {
        'services__img--fixed': _vm.fixImage,
        'services__img--finance': _vm.isFinance,
      }
    ],
    style: ({
      maxWidth: (_vm.imageSize + "vw"),
      top: (_vm.offsetTop + "px")
    }),
    attrs: {
      "src": _vm.service.image,
      "alt": ""
    }
  })])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c4c56e8"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/services/Services.vue
// module id = 540
// module chunks = 0